// src/ClientDetails.js
import React, { useEffect, useState } from "react";
import { apiFetch } from "./api";
import CommandModal from "./CommandModal";
import ResultModal from "./ResultModal";
import FileExplorerModal from "./FileExplorerModal"; // Make sure this is imported

const COMMANDS = [
  { type: "shell", label: "Run Shell Command" },
  { type: "screenshot", label: "Take Screenshot" },
  { type: "list_drives", label: "List Drives (Initial for Explorer)" }, // Can be used to get initial paths
  { type: "system_info", label: "System Info" },
  { type: "download_file", label: "Download File (from path)" },
  { type: "zip_and_download", label: "Zip & Download Folder (from path)" },
  // list_directory is best handled by FileExplorerModal itself
];

export default function ClientDetails({ client, onClose }) {
  const [commands, setCommands] = useState([]);
  const [showCmd, setShowCmd] = useState(null); // For generic CommandModal
  const [showResult, setShowResult] = useState(null);
  const [showFileExplorer, setShowFileExplorer] = useState(false); // New state for FileExplorerModal

  useEffect(() => {
    if (client && client.id) { // Ensure client.id is available
        apiFetch(`/commands/${client.id}`).then(data =>
            setCommands(data.commands || [])
        ).catch(err => console.error("Failed to fetch commands:", err));
    }
  }, [client, showCmd, showFileExplorer]); // Refresh commands if explorer or cmd modal was used

  if (!client) return null; // Or some loading/error state

  return (
    <div className="modal">
      <div className="modal-content modal-content-scrollable">
        <button className="close" onClick={onClose}>×</button>
        <h3 style={{ marginTop: 0 }}>
          Client: <span style={{ fontWeight: 600 }}>{client.hostname}</span>
        </h3>
        <div className="command-buttons">
          {/* Button to open the File Explorer */}
          <button
            onClick={() => setShowFileExplorer(true)}
            style={{ margin: "0 0 8px 0", background: "#4CAF50" }} // Different color for distinction
          >
            Browse Files (Explorer)
          </button>

          {/* Buttons for other generic commands */}
          {COMMANDS.map(cmd => (
            <button
              key={cmd.type}
              onClick={() => setShowCmd(cmd.type)}
              style={{ margin: "0 0 8px 0" }}
            >
              {cmd.label}
            </button>
          ))}
        </div>
        <h4 style={{ marginTop: 24 }}>Command History</h4>
        <div className="command-history-table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Status</th>
                <th>Created</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {commands.map(cmd => (
                <tr key={cmd.id}>
                  <td>{cmd.type}</td>
                  <td>{cmd.status}</td>
                  <td>{cmd.created_at ? new Date(cmd.created_at).toLocaleString() : 'N/A'}</td>
                  <td>
                    <button onClick={() => setShowResult(cmd.id)}>
                      View Result
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Render Generic Command Modal */}
        {showCmd && (
          <CommandModal
            clientId={client.id}
            type={showCmd}
            onClose={() => setShowCmd(null)}
            onSuccess={() => {
              setShowCmd(null);
              // Optionally trigger a refresh of commands list here if needed
            }}
          />
        )}

        {/* Render File Explorer Modal */}
        {showFileExplorer && (
          <FileExplorerModal
            client={client}
            // You can pass an initialPath if you have one, e.g., from a "list_drives" result
            // initialPath={"C:\\Users"} // Example
            onClose={() => setShowFileExplorer(false)}
          />
        )}

        {/* Render Result Modal */}
        {showResult && (
          <ResultModal
            commandId={showResult}
            onClose={() => setShowResult(null)}
          />
        )}
      </div>
    </div>
  );
}
